<template lang='pug'>
  .custom-radios(@click='promoCodeSelected')
    input(
      type='radio'
      :id='code'
      name="discount-coupon"
    )
    label(:for='code')
      img(src="../../assets/images/promo-code/checked.svg")
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    props: {
      code: {
        type: String,
        required: true
      }
    },
    computed: {
      ...mapState({
        selectedPromoCode: state => state.cart.selectedPromoCode
      })
    },
    methods: {
      promoCodeSelected () {
        this.$store.commit('setSelectedPromoCode', this.code)
      }
    }
  }
</script>

<style lang='scss' scoped>
  .custom-radios input[type="radio"] {
    display: none;
    + label {
      color: $white;
      font-size: 14px;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      text-align: center;
      line-height: 22px;
      display: inline-block;
      vertical-align: middle;
      border: 1px solid $grey;
      img {
        width: 14px;
        opacity: 0;
        transition: all 0.3s ease;
      }
    }
  }
  .custom-radios input[type="radio"]:checked + label {
    background-color: $black;
    border: 1px solid $black;
    img {
      opacity: 1;
    }
  }
</style>
